import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Input from '../../../../components/Input/Input';
import Button from '../../../../components/Button/Button';
import { validateTokenForm } from '../../../../utils/validations/formValidations';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './AddToken.css';
//services
import { tokensService } from '../../../../services/Tokens';
//components
import Modal from '../../../../components/Modal/Modal';

const AddToken = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [title, setTitle] = useState(' the following data');
  const [titleHighlight, setTitleHighlight] = useState('Insert');
  const [action, setAction] = useState('add');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [titleModal, setTitleModal] = useState({text: 'Package', highlight: 'created'});
  const [messageModal, setMessageModal] = useState('Package created successfully');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    price: 0,
    tokens: 0,
    status: 'active',
    discount: 0,
    is_deleted: false,
    expiration_date: ''
  });
  const [errors, setErrors] = useState({
    name: '',
    price: '',
    tokens: ''
  });

  useEffect(() => {
    const id = location.pathname.split('/').pop();
    if(!Number.isNaN(Number(id))) {
      setAction(location.state.action);
      const token = location.state.token;
      setFormData({
        id: id,
        name: token.name,
        price: token.price,
        tokens: token.tokens,
        discount: token.discount,
        expiration_date: token.expiration_date,
        status: token.status,
        is_deleted: token.is_deleted
      });
      if(location.state.action === 'edit'){
        setTitle(' package');
        setTitleHighlight('Edit');
      }else{
        setTitle('of the package');
        setTitleHighlight('Detail');
      }
    }else{
      setAction('add');
    }
  }, [location.pathname, location.state]);

  const handleChange = (e, field) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = async() => {
    const { errors, hasErrors } = validateTokenForm(formData);
    setErrors(errors);
    return !hasErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      if(action === 'edit'){
        const id = formData.id;
        delete formData.id;
        tokensService.update(id, formData)
          .then(() => {
            responseSuccess('edit');
          })
          .catch(error => {
            console.error('Error updating token:', error);
            responseError();
          });
      }else{
        delete formData.id;
        tokensService.create(formData)
          .then(() => {
            responseSuccess('add');
          } )
          .catch(error => {
            console.error('Error creating token:', error);
            responseError();
          });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      responseError();
    }
  };

  const responseSuccess = (action) => {
    setTitleModal({text: 'Package', highlight: action === 'edit' ? 'updated' : 'created'});
    setMessageModal(action === 'edit' ? 'Package updated successfully' : 'Package created successfully');
    setIsErrorModal(false);
    setIsModalOpen(true);
  };

  const responseError = () => {
    setTitleModal('Package');
    setMessageModal('Failed to create package');
    setIsErrorModal(true);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    navigate('/dashboard/tokens');
  };

  return (
    <div className="add-token-page">
      <div className="add-token-container">
        <div className="title-container">
          <h5 className="page-title">
            <span className="highlight">{titleHighlight}</span> {title}
          </h5>
        </div>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-row">
            <div className="form-group">
              <label>Package name*</label>
              <Input
                type="text"
                placeholder="Enter the package name"
                value={formData.name}
                onChange={(e) => handleChange(e, 'name')}
                error={errors.name}
                required
                disabled={action === 'detail'}
                size="small"
              />
            </div>
            <div className="form-group">
              <label>Quantity*</label>
              <Input
                type="number"
                placeholder="Enter the quantity"
                value={formData.tokens}
                onChange={(e) => handleChange(e, 'tokens')}
                error={errors.tokens}
                required
                disabled={action === 'detail'}
                size="small"
              />
            </div>
            <div className="form-group">
              <label>Price*</label>
              <Input
                type="number"
                placeholder="Enter the price"
                value={formData.price}
                onChange={(e) => handleChange(e, 'price')}
                error={errors.price}
                required
                disabled={action === 'detail'}
                size="small"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Discount*</label>
              <Input
                type="number"
                placeholder="Enter the discount"
                value={formData.discount}
                onChange={(e) => handleChange(e, 'discount')}
                disabled={action === 'detail'}
                size="small"
              />
            </div>
            <div className="form-group">
              <label>Expiration date*</label>
              <div className="input-container">
                <div className="input-wrapper">
                  <DatePicker
                    selected={formData.expiration_date ? new Date(formData.expiration_date) : null}
                    onChange={(date) => {
                      setFormData(prev => ({
                        ...prev,
                        expiration_date: date ? date.toISOString().split('T')[0] : ''
                      }));
                    }}
                    placeholderText="Enter the expiration date"
                    dateFormat="yyyy-MM-dd"
                    className={`style-input ${action === 'detail' ? 'disabled' : ''} small`}
                    disabled={action === 'detail'}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="form-group"></div>
          </div>

          {(action === 'edit' || action === 'add') && (
            <div className="form-actions">
              <Button
                type="button"
                onClick={handleCancel}
                variant="warning"
              borderRadius={20}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
                borderRadius={20}
              >
                {action === 'edit' ? 'Update' : 'Save'}
              </Button>
            </div>
          )}
        </form>
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={titleModal}
          showConfirmButton={true}
          confirmText="Confirm"
          onConfirm={() => {
            if(isErrorModal){
              setIsModalOpen(false);
            }else{
              navigate('/dashboard/tokens');
            }
          }}
          message={messageModal}
          error={isErrorModal}
        />
      </div>
    </div>
  );
};

export default AddToken;
